/** Arrow between from/to metrics (or before the lock) on allocation-preview rows. */
export function RightArrowIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' aria-hidden='true'>
      <path
        d='M2.5 7h9m0 0L8 3.5M11.5 7 8 10.5'
        stroke='#8E9393'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
